/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Fade } from "react-reveal";
import "./Background.css";

export default function Background() {
  return (
    <div className="backgroundSection" id="intro">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 mx-auto">
            <Fade top>
              <h2 className="en">FAIR IS OUR VALUE</h2>
              <br />
              <h2 className="ar">العدل قيمُنا</h2>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
}
